._templateEditBanner_1ousx_1 {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: #f7f8f8; }

._templateEditBannerText_1ousx_9 {
  font-family: 'Madefor'; }
